"use client";

import * as React from "react";
import { getType } from "@quovy/field-types";

export interface ValueEditorProps {
  /** Field-type name registered in `@quovy/field-types`. */
  type: string;
  value: unknown;
  options?: unknown;
  onCommit: (next: unknown) => void;
  onCancel: () => void;
}

/**
 * Registry-first inline editor. Resolves the field-type entry from
 * `@quovy/field-types` and delegates to its `edit` renderer.
 */
export function ValueEditor({ type, value, options, onCommit, onCancel }: ValueEditorProps) {
  const entry = getType(type);
  return (
    <>
      {entry.edit({
        value,
        ...(options !== undefined ? { options } : {}),
        onCommit,
        onCancel,
      })}
    </>
  );
}
